import { useEffect, useState } from "react";
import GeoJsonLayer from "./GeoJsonLayer";
import Legend from "../legend/Legend";
import { fetchDataset } from "../../utils/googleSpreadsheet";

const GoogleSpreadsheetLayer = (props) => {
  const [data, setData] = useState();
  const { layerId, data: sheet, paint, popupTemplate } = props;

  useEffect(() => {
    fetchDataset(sheet).then(setData);
  }, [sheet]);

  if (!data) {
    return null;
  }

  const source = {
    type: "geojson",
    data,
  };

  return (
    <>
      <GeoJsonLayer
        id={layerId}
        source={source}
        paint={paint}
        popupTemplate={popupTemplate}
      />
      <Legend {...props} />
    </>
  );
};

export default GoogleSpreadsheetLayer;
